// removed by extract-text-webpack-plugin
module.exports = {"component":"_3a45uc8iX3iGAJyPDI09Yl","js_ul":"LFEqyIj6M9mi8W1oMKJ5","js_li":"_2gTixP2mceCbaL8UoT4dsh","border":"IJSwCBHUd7CRMHfrnyQ-P","js_all_sou":"_11qbQaKd8z89D4_SB0ezl7","input":"qukvOpysOQB6FlrnpqWpZ","img":"_1wv9JPDapVgA37gkFYcYl","selt":"KNX9v2sGmCFSjH2w-iYXR","bk_zs_link":"_3gEI5oQ8dIzwB2B0Lhpmlj","allTable":"_1lgqVjcPcm0dk7UvXCbFen","quanxuan":"_160XlL4s4i9OalnpLusFs2","rightBtn":"BtrvpydswUdA6XIXy8xSZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PreferentialMessage/PreferentialMessage.scss
 ** module id = 1090
 ** module chunks = 0
 **/